<template>
    <v-container>
        <v-card flat>
            <v-card-text>
                <v-layout row>
                    <v-spacer></v-spacer>
                    <v-flex md5 class="text-md-center">
                            <h2>
                                <span style="color:#000;">Amount: </span>
                                <span style="color:blue;">{{helper.numberFormat.formatPrice(getAmountToPay)}}</span>&nbsp;<span style="color:#000;">{{getCurrencyToPay}}</span>
                            </h2>
                        </v-flex>
                    <v-spacer></v-spacer>                    
                </v-layout>
                <v-divider></v-divider>
                <v-layout row mt-3>
                    <v-spacer></v-spacer>
                    <v-flex md5 class="text-md-center">
                        <h3>{{!isQrPayment? 'Select Card Type':''}}</h3>
                        </v-flex>
                    <v-spacer></v-spacer>
                </v-layout>
                <v-layout row wrap class="text-md-center">
                    <v-spacer></v-spacer>
                    <v-flex md9 v-if="!isQrPayment">
                        <v-item-group>
                            <v-container grid-list-md>
                                <v-layout wrap row>
                                    <v-spacer></v-spacer>
                                    <v-flex :class="isMobile? (img.url.length>1? 'xs12':'xs12'):(img.url.length>1? 'md3':'md2')" 
                                        style="text-align:center;" v-for="(img,index) in getCardGroups" :key="index">
                                        <v-card
                                            :class="'d-flex align-center'"
                                            :height="isMobile? 50:80"
                                            :style="(isMobile?'padding-top:20px;':'padding-top:15px;') + ' ' 
                                            + (selectedCardType==index? 'border:solid 3px ' + theme.primary.base :'border:none')"   
                                            @click="selectCardType(index)"                   
                                            :flat="(selectedCardType==index? true:false)"    
                                        >
                                                <v-card style="background-color:transparent;" width="50" height="50" flat v-for="(url,i) in img.url" :key="i">
                                                    <img style="max-width:46px;max-height:46px;" :src="url">
                                                </v-card>
                                        </v-card>
                                    </v-flex>
                                    <v-spacer></v-spacer>
                                </v-layout>
                            </v-container>
                        </v-item-group>
                    </v-flex>
                    <v-flex md9 v-if="isQrPayment && qrDisplayOption!='SCB'" style="text-align:center;">
                        <img style="max-width:92px;max-height:92px;" :src="getCardGroups[0].url[0]">
                    </v-flex>                    
                    <v-spacer></v-spacer>

                    
                </v-layout>
  



                <v-layout row wrap>
                    <v-flex>
                        <ScbQr v-if="qrDisplayOption=='SCB'" :searchId="searchId" 
                            :merchantCode="cardPaymentInfo.merchantCode" 
                            :paymentCode="cardPaymentInfo.paymentCode"></ScbQr>
                        <v-dialog v-model="gbQrDialog" fullscreen hide-overlay transition="dialog-bottom-transition">                            
                        <GbQr v-if="qrDisplayOption=='GB'" :searchId="searchId" 
                            :paymentCode="cardPaymentInfo.paymentCode"
                            :merchantCode="this.cardPaymentInfo.merchantCode"
                            @showDialog="s=>{gbQrDialog=s}"></GbQr>
                        </v-dialog>
                    </v-flex>
                </v-layout>
                <v-layout row wrap v-if="qrDisplayOption!='SCB'">
                        <v-spacer></v-spacer>
                        <v-flex md8 sm12 xs12 style="text-align:center;">
                            <v-checkbox
                            v-model="termsChecked"
                            >
                            <template v-slot:label>
                                <div v-html="cardPaymentInfo.paymentCondition"></div>   
                            </template>
                            </v-checkbox>     
                        </v-flex>
                        <v-spacer></v-spacer>
                </v-layout>
                <v-layout v-if="qrDisplayOption!='SCB'">
                    <v-spacer></v-spacer>
                    <v-flex md2 sm7 xs7 style="text-align:center;">
                        <v-btn dark color="primary" @click="btnPay_Click(searchId,selectedCardType==1)">PAY</v-btn>  
                        <div v-html="this.gmcForm"></div> 
                        <form id="formGMC" ref="formGmc" style="display:none;" method="post" 
                            :action="gmcFormData.actionUrl">
                            <input type="text" :value="gmcFormData.merchantCode" name="MERCHANTCODE" id="MERCHANTCODE">
                            <input type="text" :value="gmcFormData.paymentCode" name="PAYMENTCODE" id="PAYMENTCODE">
                            <input type="text" :value="gmcFormData.productDesc" name="PRODUCTDESC" id="PRODUCTDESC">
                            <input type="text" :value="gmcFormData.returnUrl" name="RETURNURL" id="RETURNURL">
                            <input type="text" :value="gmcFormData.backendUrl" name="BACKENDURL" id="BACKENDURL">
                            <input type="text" :value="gmcFormData.amount" name="AMOUNT" id="AMOUNT">
                            <input type="text" :value="gmcFormData.currency" name="CURRENCY" id="CURRENCY">
                            <input type="text" :value="gmcFormData.ref1" name="REF1" id="REF1">
                            <input type="text" :value="gmcFormData.ref2" name="REF2" id="REF2">
                            <input type="text" :value="gmcFormData.ref3" name="REF3" id="REF3">
                            <input type="text" :value="gmcFormData.ref4" name="REF4" id="REF4">
                            <input type="text" :value="gmcFormData.ref5" name="REF5" id="REF5">
                            <input type="text" :value="gmcFormData.successUrl" name="SuccessUrl" id="SuccessUrl">
                            <input type="text" :value="gmcFormData.failUrl" name="FailUrl" id="FailUrl">
                            <input type="text" :value="gmcFormData.cancelUrl" name="CancelUrl" id="CancelUrl">
                        </form>
                    </v-flex>
                    <v-spacer></v-spacer>
                </v-layout>
                <v-layout row wrap>
                    <v-flex class="text-md-center">
                        <div v-if="showWarning1" style="position:absolute;">
                                <v-icon color="red">warning</v-icon>
                            <b style="color:red;">
                                {{warning1Message}}
                            </b>
                        </div>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-container>

</template>

<script>
import BookingService from '../../services/booking.service'
import Helper from '../helper';
import Theme from '../../theme';
import GbQr from './GbQrPayment';
import ScbQr from './ScbQrPayment';

export default {
    components:{
        GbQr,
        ScbQr
    },
    props:["cardPaymentInfo","searchId","isQrPayment", "sellingCurrency"],
    data(){
        return {
            gbQrDialog:false,
            tempData:"Hellow World!",
            termsChecked:false,
            gmcForm:null,
            gmcFormData:{
                actionUrl:"",
                merchantCode:"",
                paymentCode:"",
                productDesc:"",
                returnUrl:"",
                backendUrl:"",
                amount:"",
                currency:"",
                ref1:"",
                ref2:"",
                ref3:"",
                ref4:"",
                ref5:"",
                successUrl:"",
                failUrl:"",
                cancelUrl:"",
            },
            selectedCardType: 0,
            theme:Theme,
            showWarning1:false,
            warning1Message:"",
            helper:Helper,
            qrDisplayOption:""
        }
    },
    created(){
    },
    computed:{
        isMobile(){
            let isMobile = Helper.display.isMobile(this.$vuetify.breakpoint.name);
            return isMobile;
        },      
        getCardGroups(){
            let allCards =[];
            let mkr = "";
            let mrkIndex=0;
            this.cardPaymentInfo.imageUrls.forEach( c => {
                let crd = c.split('|');
                if (mkr!=crd[0]){
                    mkr=crd[0];
                    allCards.push({
                        key:crd[0],
                        url:[crd[1]],
                    })                    
                }else {
                    allCards[mrkIndex].url.push(crd[1]);  
                }
            });
            return allCards;
        },
        getAmountToPay(){
          let amnt = this.cardPaymentInfo.grandTotal
          if (this.sellingCurrency != null) {
            amnt  = this.helper.sellingCurrency.convertByFxRate(this.sellingCurrency.FxRate, amnt)
          }
          return amnt
        },
        getCurrencyToPay() {
          let curr = this.cardPaymentInfo.currency
          if (this.sellingCurrency != null) {
            curr = this.sellingCurrency.CurrencyCode
          }
          return curr
        }
    },
    methods:{
        displayScbQr(){
            this.qrDisplayOption = "SCB";
        },
        displayGbQr(){
            this.gbQrDialog=true;
            this.qrDisplayOption = "GB";
        },
        btnPay_Click(sid,useAmex=false){
            if (this.cardPaymentInfo.paymentCode=="SCB_QR_PAYMENT"){
                if (this.termsChecked){
                    this.displayScbQr();
                }else{
                    this.warning1Message = "Please accept payment terms and conditions.";
                    this.showWarning1 = true;
                }                 
            }else if (this.cardPaymentInfo.paymentCode=="GB_QR_PAYMENT"){
                if (this.termsChecked){
                    this.displayGbQr();  
                }else{
                    this.warning1Message = "Please accept payment terms and conditions.";
                    this.showWarning1 = true;
                }                
            }
            else{
                this.qrDisplayOption = "";
                this.getGmcForm(sid,useAmex);
            }
            
        },
        selectCardType(id){
            this.selectedCardType = id;
        },
        submitForm(){
            if (this.termsChecked){
                if (this.selectedCardType<0){
                    this.warning1Message = "Please select card type.";
                    this.showWarning1 = true;                    
                    return;
                }
                this.$refs.formGmc.submit();   
            }else{
                this.warning1Message = "Please accept payment terms and conditions.";
                this.showWarning1 = true;
            }
        },
        getGmcForm(sid,useAmex=false){
            this.warning1Message = "";
            this.showWarning1 = false;
            let paymentCode = useAmex? this.cardPaymentInfo.amexPaymentCode:this.cardPaymentInfo.paymentCode;
            BookingService.getGmcForm(sid,paymentCode,this.cardPaymentInfo.merchantCode).then(rslt=>{
                let formData = rslt.data.GMCFormObj;
                //this.gmcForm = rslt.data.GMCForm;

                try {
                    this.gmcFormData.actionUrl = formData.ActionUrl;  
                    this.gmcFormData.amount = formData.Amount.toFixed(2);
                    this.gmcFormData.backendUrl = formData.BackEndUrl;
                    this.gmcFormData.cancelUrl = formData.CancelUrl;
                    this.gmcFormData.currency = formData.Currency;
                    this.gmcFormData.failUrl = formData.FailUrl;
                    this.gmcFormData.merchantCode = formData.MerchantCode;
                    this.gmcFormData.paymentCode = formData.PaymentCode;
                    this.gmcFormData.ref1 = formData.Ref1;
                    this.gmcFormData.ref2 = formData.Ref2;
                    this.gmcFormData.ref3 = formData.Ref3;
                    this.gmcFormData.ref4 = formData.Ref4;
                    this.gmcFormData.ref5 = formData.Ref5;
                    this.gmcFormData.returnUrl = formData.ReturnUrl;
                    this.gmcFormData.successUrl = formData.SuccessUrl;
                    this.gmcFormData.productDesc = "GO - " + formData.Ref2;
                } catch (error) {
                    if (rslt.data.indexOf("QrCodePay")>=0){
                        this.gmcFormData.actionUrl = "https://go2api.galileo.co.th" + rslt.data;
                    }                        
                }
                
                setTimeout(() => {
                    this.submitForm();  
                }, 2000);
                
            });
        },
    }
}
</script>

<style>

</style>